<template>
  <div :class="bem.b()">
    <div :class="bem.m('title')">
      <p>筛选结果：</p>
      <a @click="handleClean(null)">清除筛选结果</a>
    </div>
    <div v-if="tags.length > 0" :class="bem.m('box')">
      <div v-for="tag in tags" :key="tag.key" :class="bem.m('tag')">
        <span :class="bem.m('label')">{{ tag.label }}：</span>
        <span :class="bem.m('value')">{{ tag.showValue }}</span>
        <span :class="bem.m('close')" @click="handleClean(tag)">
          <ll-icon icon-name="icon-close2" :class-name="bem.m('icon')" />
        </span>
      </div>
    </div>
    <div v-else :class="bem.m('empty')">
      <span>暂无数据</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import { ref, watchEffect } from 'vue'

import type { FormColumn } from '@ll-plus/components'
import { createNamespace, hasValue } from '@ll-plus/utils'
import { has } from 'lodash-es'
import {
  advancedFilteringProps,
  advancedFilteringTagsEmits,
  filterAllValue,
  findLabelByValue,
  treeDataFormat,
  type IAdvancedFilteringTag,
} from '../advanced-filtering'
defineOptions({ name: 'LlAdvancedFilteringTags' })
const props = defineProps(advancedFilteringProps)
const emits = defineEmits(advancedFilteringTagsEmits)
const bem = createNamespace('advanced-filtering-tags')
const tags = ref([] as IAdvancedFilteringTag[])

const handleClean = (tag: IAdvancedFilteringTag | null = null) => {
  const copyValue = {}
  if (tag) {
    tags.value = tags.value.filter((e) => e.key !== tag.key)
  } else {
    tags.value = []
  }
  tags.value.map((e) => {
    copyValue[e.key] = e.value
  })
  setData(copyValue)
}
const setData = (obj: Record<string, any>) => {
  emits('update:value', obj)
  emits('change', obj)
}

const getTags = (filterColumns: FormColumn[], values: Record<string, any>) => {
  const arr = [] as IAdvancedFilteringTag[]
  filterColumns.map((item: any) => {
    const value = filterAllValue(values[item.key], item)
    if (hasValue(value)) {
      let tagValue = ''

      if (item?.options) {
        let options = [] as FormColumn['options']
        if (item.fieldNames) {
          options = treeDataFormat(options, item.fieldNames)
        } else {
          options = item.options
        }
        if (Array.isArray(value)) {
          let tagArr: any = []
          tagArr = value.map((val: string) => {
            return findLabelByValue(options, val)
          })

          tagValue = tagArr.join(',')
        } else {
          tagValue = findLabelByValue(options, value)
        }
      } else {
        tagValue = value
      }

      if (item.type === 'date-picker') {
        tagValue = dayjs(value).format(item?.format ?? 'YYYY-MM-DD')
      }
      if (item.type === 'time-picker') {
        tagValue = dayjs(value).format(item?.format ?? 'YYYY/MM/DD hh:mm:ss')
      }
      if (item.type === 'date-range') {
        tagValue = `${dayjs(value[0]).format(
          item?.format ?? 'YYYY-MM-DD'
        )} - ${dayjs(value[1]).format(item?.format ?? 'YYYY-MM-DD')}`
      }

      if (item.type === 'number-range') {
        tagValue = `${value[0]}${value[1] ? ` - ${value[1]}` : ''}`
      }

      if (item.type === 'time-range') {
        tagValue = `${dayjs(value[0]).format(
          item?.format ?? 'YYYY/MM/DD HH:mm:ss'
        )} - ${dayjs(value[1]).format(item?.format ?? 'YYYY/MM/DD HH:mm:ss')}`
      }

      if (item.type === 'switch') {
        if (
          has(item, 'checkedChildren') &&
          has(item, 'checkedValue') &&
          has(item, 'unCheckedChildren') &&
          has(item, 'unCheckedValue')
        ) {
          tagValue =
            value === item.checkedValue
              ? item.checkedChildren
              : item.unCheckedChildren
        }

        if (has(item, 'checkedChildren') && !has(item, 'checkedValue')) {
          tagValue = value ? (item as any).checkedChildren : false
        }
      }
      if (tagValue) {
        arr.push({
          label: item.label || '',
          key: item.key,
          value: value,
          showValue: tagValue,
        })
      }
    }
  })
  return arr
}

watchEffect(() => {
  tags.value = getTags(props.filterColumns, props.value)
})
</script>
